"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.originalSetTimeout = exports.START = exports.SPA_NODE = exports.REMAINING = exports.MAX_TIMER_BUDGET = exports.JS_TIME = exports.JSONP_NODE = exports.JSONP_END = exports.INTERACTION_EVENTS = exports.INTERACTION_API = exports.INTERACTION = exports.FN_START = exports.FN_END = exports.FETCH_START = exports.FETCH_DONE = exports.FETCH_BODY = exports.FETCH = exports.FEATURE_NAME = exports.END = exports.CB_START = exports.CB_END = exports.BODY = void 0;
var _config = require("../../common/config/config");
var _features = require("../../loaders/features/features");
const FEATURE_NAME = exports.FEATURE_NAME = _features.FEATURE_NAMES.spa;
const INTERACTION_EVENTS = exports.INTERACTION_EVENTS = ['click', 'submit', 'keypress', 'keydown', 'keyup', 'change'];
const MAX_TIMER_BUDGET = exports.MAX_TIMER_BUDGET = 999;
const FN_START = exports.FN_START = 'fn-start';
const FN_END = exports.FN_END = 'fn-end';
const CB_START = exports.CB_START = 'cb-start';
const INTERACTION_API = exports.INTERACTION_API = 'api-ixn-';
const REMAINING = exports.REMAINING = 'remaining';
const INTERACTION = exports.INTERACTION = 'interaction';
const SPA_NODE = exports.SPA_NODE = 'spaNode';
const JSONP_NODE = exports.JSONP_NODE = 'jsonpNode';
const FETCH_START = exports.FETCH_START = 'fetch-start';
const FETCH_DONE = exports.FETCH_DONE = 'fetch-done';
const FETCH_BODY = exports.FETCH_BODY = 'fetch-body-';
const JSONP_END = exports.JSONP_END = 'jsonp-end';
const originalSetTimeout = exports.originalSetTimeout = _config.originals.ST;
const START = exports.START = '-start';
const END = exports.END = '-end';
const BODY = exports.BODY = '-body';
const CB_END = exports.CB_END = 'cb' + END;
const JS_TIME = exports.JS_TIME = 'jsTime';
const FETCH = exports.FETCH = 'fetch';